import { useEffect } from 'react'
import ScrollTrigger from 'gsap/dist/ScrollTrigger'
import Lenis from 'lenis'
import { useLenis } from 'lenis/react'
import { useRouter } from 'next/router'

import { useLenisStore } from '@/contexts/lenis'

const Controller = () => {
  const lenis = useLenis()
  const router = useRouter()
  const setLenisState = useLenisStore((state) => state.setState)

  /**
   * setup
   */
  useEffect(() => {
    if (!lenis) return

    window.scrollTo({ top: 0, left: 0 })

    const update = ({ scroll, limit, progress, direction }: Lenis) => {
      setLenisState({
        scroll,
        limit,
        progress,
        direction,
        halfway: progress >= 0.5,
        complete: progress >= 1
      })
    }

    lenis.on('scroll', update)

    return () => {
      lenis.off('scroll', update)
    }
  }, [lenis, setLenisState])

  useEffect(() => {
    ScrollTrigger.clearScrollMemory('manual')

    router.beforePopState((state) => {
      state.options.scroll = false
      return true
    })
  }, [router])

  return null
}

export default Controller
